module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "location"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "loader",
    class: {
      none: !_vm.isRequestActive
    }
  }, [_c('looping-rhombuses-spinner', {
    style: ({
      'color': _vm.customization.mainColor
    }),
    attrs: {
      "animation-duration": 1500,
      "rhombus-size": 15
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "logo_on_map"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.logo
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "layout_fullwidth_padding"
  }, [_c('h3', [_vm._v("Our Location")]), _vm._v(" "), _c('iframe', {
    staticClass: "map",
    attrs: {
      "src": _vm.mapUrl,
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('blockquote', {
    style: (_vm.borderStyle)
  }, [_c('b', [_vm._v("Adress: ")]), _vm._v(" " + _vm._s(_vm.adress) + "\n        ")]), _vm._v(" "), _c('h3', [_vm._v("Hours of Operation")]), _vm._v(" "), _c('table', [_c('tr', [_c('th', {
    style: (_vm.borderStyle)
  }, [_vm._v("Day")]), _vm._v(" "), _c('th', {
    style: (_vm.borderStyle)
  }, [_vm._v("Hours")])]), _vm._v(" "), (this.workHours.Mf != undefined) ? _c('tr', [_c('td', [_vm._v(_vm._s(this.workHours.Mf.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.workHours.Mf.time))])]) : _vm._e(), _vm._v(" "), (this.workHours.Sat != undefined) ? _c('tr', [_c('td', [_vm._v(_vm._s(this.workHours.Sat.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.workHours.Sat.time))])]) : _vm._e(), _vm._v(" "), (this.workHours.Sun != undefined) ? _c('tr', [_c('td', [_vm._v(_vm._s(this.workHours.Sun.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.workHours.Sun.time))])]) : _vm._e()])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-52eac35c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52eac35c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/about/about-company.vue
// module id = 776
// module chunks = 0